// extracted by mini-css-extract-plugin
export default {"districtIt":"District_districtIt__w62mV"};